import React from "react";

import { View, ActivityIndicator, StyleSheet } from "react-native";
import AppTheme from "../AppTheme";

export default function LoadingIndicator({ isLoading }) {
  return (
    <>
      {isLoading ? (
        <View style={styles.loading}>
          <ActivityIndicator size="large" color={AppTheme.DEFAULT_COLOR} />
        </View>
      ) : null}
    </>
  );
}

const styles = StyleSheet.create({
  loading: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
    backgroundColor: "rgba(255, 255, 255, 0.6)",
  },
});
